export const outcomeGoalMetrics = ["referrals", "careStarts"];
export const outcomeGoalMetricLabels = {
    referrals: "Referrals received",
    careStarts: "Care started",
};
export const outcomeGoalMetricShortLabels = {
    referrals: "Referrals",
    careStarts: "Care started",
};
export const zeroTargets = () => ({
    activity: {},
    referrals: 0,
    careStarts: 0,
});
export const goalMetricItemLinkKinds = [
    "placement",
    "homeCare",
    "referenceContact",
    "referenceBusiness",
    "community",
];
//# sourceMappingURL=marketing-goal.js.map